import { VertexInfo } from "verdi-common/schemas/commonSubSchemas/vertexInfo";
import { Zone } from "verdi-common/schemas/zone/zone.js";
import { SoilLayer } from "../Models/soilLayer.js";
import { SessionHandler } from "./SessionHandler.js";

export class ZoneAPI {
    /**
     * Allows you to update the label, and vertices of a zone
     * @param {string} zoneID
     * @param {Partial<Zone>} props
     * @return {Promise<any>}

     */
    static async editOne(zoneID: string, props: Partial<Zone> = {}): Promise<Zone> {
        let properlyFormattedPolygons = undefined;
        if (props.polygons) {
            if (Array.isArray(props.polygons) && Array.isArray(props.polygons[0])) {
                properlyFormattedPolygons = props.polygons;
            } else {
                properlyFormattedPolygons = [props.polygons];
            }
        }
        let soilLayersArg = undefined;
        if (props.soilLayers && Array.isArray(props.soilLayers)) {
            soilLayersArg = props.soilLayers.map((sl) => {
                if (sl instanceof SoilLayer) {
                    return sl.getJSON();
                }
                return sl;
            });
        }
        const response = SessionHandler.doFetch("zones/edit/" + zoneID, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "PATCH",
            body: JSON.stringify({
                name: props.name || undefined,
                polygons: properlyFormattedPolygons || undefined,
                soilLayers: soilLayersArg || undefined,
                fieldCapacityVolumetricFraction: props.fieldCapacityVolumetricFraction,
                userMetadata: props.userMetadata || undefined,
                defaultRelativeIrrigationDuration: props.defaultRelativeIrrigationDuration || undefined,
                recommendedRelativeIrrigationDuration: props.recommendedRelativeIrrigationDuration || undefined,
                supplementalZoneGraphInfo: props.supplementalZoneGraphInfo || undefined,
            }),
            redirect: "follow",
        });
        return await (await response).json();
    }

    /**
     * Creates a new zone
     * @param {VertexInfo[][]} polygons
     * @param {String} name
     * @return {Promise<Zone>}
     */
    static async addOne(polygons: VertexInfo[][], name: string): Promise<{ zone: Zone }> {
        const response = await SessionHandler.doFetch("zones/", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                name: name,
                polygons: polygons,
            }),
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * @param {String} zoneID ID of th zone to delete
     * @return {Promise<boolean>}
     */
    static async deleteOne(zoneID: string): Promise<boolean> {
        const response = await SessionHandler.doFetch("zones/" + zoneID, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "DELETE",
            redirect: "follow",
        });
        if (response.ok) return true;
        else {
            throw new Error("Zone not deleted");
        }
    }
}
